export default __webpack_public_path__ + "static/media/podium.ed28e2d8.svg";